import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterOutlet } from '@angular/router';
import { LayoutComponent } from './shared/components/layout/layout.component';
import {ToastModule} from 'primeng/toast';

@Component({
  selector: 'pegasus-root',
  standalone: true,
  imports: [CommonModule, RouterOutlet, LayoutComponent, ToastModule],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
})
export class AppComponent implements OnInit {
  title = 'pegasus-ui';

  constructor() {}

  ngOnInit() {}
}
